// extracted by mini-css-extract-plugin
export default {"icon":"whatsapp_icon__PKbRv","whatsappchat":"whatsapp_whatsappchat__8a73M"};